<template>
    <div>

        <app-toolbarcustom
            app_title="Form Dinas dan Meeting di Luar Kantor"
            app_menu="employeeleavemeeting"
        ></app-toolbarcustom>

        <template>
            <v-stepper v-model="steppers" class="mt-15 elevation-0">

                <v-stepper-header>
                    <v-stepper-step
                        :complete="steppers > 1"
                        step="1"
                    >
                        Form
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step
                        :complete="steppers > 2"
                        step="2"
                    >
                        Summary
                    </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>

                    <!-- ===================================================== -->
                    <!-- STEP 1 -->
                    <!-- ===================================================== -->
                    <v-stepper-content step="1">

                        <v-card class="mb-12 elevation-0">

                            <v-form
                                enctype="multipart/form-data"
                                ref="form_leave_data"
                                lazy-validation
                            >

                                <v-row>

                                    <!-- KATEGORI -->
                                    <v-col cols="12" class="mt-2">

                                        <v-radio-group
                                            v-model="form.leave_category"
                                            row
                                        >
                                            <v-radio
                                                label="Meeting di Luar Kantor"
                                                value="MK"
                                            />

                                            <v-radio
                                                label="Dinas"
                                                value="DN"
                                            />

                                            <v-radio
                                                label="Pelatihan"
                                                value="PL"
                                            />
                                        </v-radio-group>

                                    </v-col>


                                    <!-- ================================================= -->
                                    <!-- TANGGAL MULAI -->
                                    <!-- ================================================= -->
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        md="12"
                                        class="mt-n6"
                                    >

                                        <v-dialog
                                            ref="dialog_leave_sdate"
                                            v-model="modal.leave_sdate"
                                            :return-value.sync="form.leave_sdate"
                                            width="290px"
                                            persistent
                                        >

                                            <template v-slot:activator="{ on }">

                                                <v-text-field
                                                    :value="leave_sdate_value"
                                                    label="Tanggal"
                                                    prepend-icon="event"
                                                    background-color="date"
                                                    v-on="on"
                                                    v-mask="'####-##-##'"
                                                    placeholder="YYYY-MM-DD"
                                                    id="find_leave_sdate"
                                                    outlined
                                                ></v-text-field>

                                            </template>

                                            <v-date-picker
                                                v-model="form.leave_sdate"
                                                :min="form.leave_category === 'CS'
                                                    ? $functions.PastDate(5)
                                                    : $functions.PastDate(0)"
                                                scrollable
                                            >

                                                <v-spacer></v-spacer>

                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="modal.leave_sdate = false"
                                                >
                                                    Cancel
                                                </v-btn>

                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="GetData('leave_sdate', form.leave_sdate)"
                                                >
                                                    OK
                                                </v-btn>

                                            </v-date-picker>

                                        </v-dialog>

                                    </v-col>


                                    <!-- ================================================= -->
                                    <!-- TANGGAL SELESAI DINAS / PELATIHAN -->
                                    <!-- ================================================= -->
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                        class="mt-n6"
                                        v-if="['DN', 'PL'].includes(form.leave_category)"
                                    >

                                        <v-dialog
                                            ref="dialog_leave_edate"
                                            v-model="modal.leave_edate"
                                            :return-value.sync="form.leave_edate"
                                            width="290px"
                                            persistent
                                        >

                                            <template v-slot:activator="{ on }">

                                                <v-text-field
                                                    :value="leave_edate_value"
                                                    label="Tanggal Selesai"
                                                    prepend-icon="event"
                                                    background-color="date"
                                                    v-on="on"
                                                    v-mask="'####-##-##'"
                                                    placeholder="YYYY-MM-DD"
                                                    outlined
                                                />

                                            </template>

                                            <v-date-picker
                                                v-model="form.leave_edate"
                                                :min="form.leave_sdate"
                                                scrollable
                                            >

                                                <v-spacer></v-spacer>

                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="modal.leave_edate = false"
                                                >
                                                    Cancel
                                                </v-btn>

                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="GetData('leave_edate', form.leave_edate)"
                                                >
                                                    OK
                                                </v-btn>

                                            </v-date-picker>

                                        </v-dialog>

                                    </v-col>


                                    <!-- ================================================= -->
                                    <!-- JAM MULAI -->
                                    <!-- MK = SELALU -->
                                    <!-- PL = HANYA JIKA 1 HARI -->
                                    <!-- ================================================= -->
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="mt-n6"
                                        v-if="
                                            form.leave_category === 'MK' ||
                                            (
                                                form.leave_category === 'PL' &&
                                                form.leave_duration === 1
                                            )
                                        "
                                    >

                                        <v-dialog
                                            ref="dialog_leave_stime"
                                            v-model="modal.leave_stime"
                                            :return-value.sync="form.leave_stime"
                                            persistent
                                            width="290px"
                                        >

                                            <template v-slot:activator="{ on }">

                                                <v-text-field
                                                    v-model="form.leave_stime"
                                                    :rules="form.leave_stime_rules"
                                                    label="Mulai *"
                                                    prepend-icon="access_time"
                                                    background-color="time"
                                                    readonly
                                                    v-on="on"
                                                    required
                                                    outlined
                                                ></v-text-field>

                                            </template>

                                            <v-time-picker
                                                v-if="modal.leave_stime"
                                                v-model="form.leave_stime"
                                                format="24hr"
                                            >

                                                <v-spacer></v-spacer>

                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="modal.leave_stime = false"
                                                >
                                                    Cancel
                                                </v-btn>

                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="GetData('leave_stime', form.leave_stime)"
                                                >
                                                    OK
                                                </v-btn>

                                            </v-time-picker>

                                        </v-dialog>

                                    </v-col>


                                    <!-- ================================================= -->
                                    <!-- JAM SELESAI -->
                                    <!-- MK = SELALU -->
                                    <!-- PL = HANYA JIKA 1 HARI -->
                                    <!-- ================================================= -->
                                    <v-col
                                        cols="6"
                                        sm="6"
                                        md="6"
                                        class="mt-n6"
                                        v-if="
                                            form.leave_category === 'MK' ||
                                            (
                                                form.leave_category === 'PL' &&
                                                form.leave_duration === 1
                                            )
                                        "
                                    >

                                        <v-dialog
                                            ref="dialog_leave_etime"
                                            v-model="modal.leave_etime"
                                            :return-value.sync="form.leave_etime"
                                            persistent
                                            width="290px"
                                        >

                                            <template v-slot:activator="{ on }">

                                                <v-text-field
                                                    v-model="form.leave_etime"
                                                    :rules="form.leave_etime_rules"
                                                    label="Berakhir *"
                                                    prepend-icon="access_time"
                                                    background-color="time"
                                                    readonly
                                                    v-on="on"
                                                    required
                                                    outlined
                                                ></v-text-field>

                                            </template>

                                            <v-time-picker
                                                v-if="modal.leave_etime"
                                                v-model="form.leave_etime"
                                                format="24hr"
                                            >

                                                <v-spacer></v-spacer>

                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="modal.leave_etime = false"
                                                >
                                                    Cancel
                                                </v-btn>

                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="GetData('leave_etime', form.leave_etime)"
                                                >
                                                    OK
                                                </v-btn>

                                            </v-time-picker>

                                        </v-dialog>

                                    </v-col>


                                    <!-- ================================================= -->
                                    <!-- LAMA MEETING -->
                                    <!-- ================================================= -->
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                        class="mt-n6"
                                        v-if="form.leave_category === 'MK'"
                                    >

                                        <v-text-field
                                            v-model="form.leave_durationtime"
                                            :readonly="true"
                                            :prepend-icon="loading.page
                                                ? 'hourglass_top'
                                                : 'event'"
                                            placeholder="Lama Meeting dalam menit"
                                            label="Lama Meeting dalam menit *"
                                            required
                                            outlined
                                            background-color="readonly"
                                        >
                                        </v-text-field>

                                    </v-col>


                                    <!-- ================================================= -->
                                    <!-- LAMA DINAS / PELATIHAN -->
                                    <!-- ================================================= -->
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                        class="mt-n6"
                                        v-else-if="['DN', 'PL'].includes(form.leave_category)"
                                    >

                                        <v-text-field
                                            v-model="form.leave_duration"
                                            :readonly="true"
                                            :prepend-icon="loading.page
                                                ? 'hourglass_top'
                                                : 'event'"
                                            :placeholder="
                                                form.leave_category === 'PL'
                                                    ? 'Lama Pelatihan dalam hari'
                                                    : 'Lama Dinas dalam hari'
                                            "
                                            :label="
                                                form.leave_category === 'PL'
                                                    ? 'Lama Pelatihan dalam hari *'
                                                    : 'Lama Dinas dalam hari *'
                                            "
                                            required
                                            outlined
                                            background-color="readonly"
                                        >
                                        </v-text-field>

                                    </v-col>


                                    <!-- ================================================= -->
                                    <!-- ALAMAT -->
                                    <!-- ================================================= -->
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                        class="mt-n6"
                                    >

                                        <v-text-field
                                            v-model="form.leave_address"
                                            :rules="form.leave_address_rules"
                                            prepend-icon="notes"
                                            :placeholder="
                                                form.leave_category === 'DN'
                                                    ? 'Alamat Dinas'
                                                    : form.leave_category === 'PL'
                                                        ? 'Alamat Pelatihan'
                                                        : 'Alamat Meeting'
                                            "
                                            :label="
                                                form.leave_category === 'DN'
                                                    ? 'Alamat Dinas *'
                                                    : form.leave_category === 'PL'
                                                        ? 'Alamat Pelatihan *'
                                                        : 'Alamat Meeting *'
                                            "
                                            required
                                            solo-inverted
                                            outlined
                                        ></v-text-field>

                                    </v-col>


                                    <!-- ================================================= -->
                                    <!-- PESERTA -->
                                    <!-- ================================================= -->
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                        class="mt-n6"
                                    >

                                        <v-text-field
                                            v-model="form.leave_participant"
                                            :rules="form.leave_participant_rules"
                                            prepend-icon="notes"
                                            :placeholder="
                                                form.leave_category === 'DN'
                                                    ? 'Peserta Dinas'
                                                    : form.leave_category === 'PL'
                                                        ? 'Peserta Pelatihan'
                                                        : 'Peserta Meeting'
                                            "
                                            :label="
                                                form.leave_category === 'DN'
                                                    ? 'Peserta Dinas *'
                                                    : form.leave_category === 'PL'
                                                        ? 'Peserta Pelatihan *'
                                                        : 'Peserta Meeting *'
                                            "
                                            required
                                            solo-inverted
                                            outlined
                                        ></v-text-field>

                                    </v-col>


                                    <!-- ================================================= -->
                                    <!-- KETERANGAN -->
                                    <!-- ================================================= -->
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                        class="mt-n6"
                                    >

                                        <v-text-field
                                            v-model="form.leave_remarks"
                                            :rules="form.leave_remarks_rules"
                                            prepend-icon="notes"
                                            :placeholder="
                                                form.leave_category === 'DN'
                                                    ? 'Keterangan Dinas'
                                                    : form.leave_category === 'PL'
                                                        ? 'Keterangan Pelatihan'
                                                        : 'Keterangan Meeting'
                                            "
                                            :label="
                                                form.leave_category === 'DN'
                                                    ? 'Keterangan Dinas *'
                                                    : form.leave_category === 'PL'
                                                        ? 'Keterangan Pelatihan *'
                                                        : 'Keterangan Meeting *'
                                            "
                                            required
                                            solo-inverted
                                            outlined
                                        ></v-text-field>

                                    </v-col>

                                </v-row>


                                <v-alert
                                    border="left"
                                    colored-border
                                    color="secondary"
                                    elevation="2"
                                    v-if="form.leave_category === 'CT'"
                                >
                                    Sisa Cuti Tahunan:
                                    {{ form.usersleave_remaining }} hari,
                                    Exp:
                                    {{
                                        $functions.FormatDateIndoWithDayName(
                                            form.usersleave_expdate
                                        )
                                    }}
                                </v-alert>

                            </v-form>

                        </v-card>


                        <v-btn
                            color="primary"
                            @click="NextStep(1)"
                            block
                        >
                            Lanjut
                        </v-btn>

                    </v-stepper-content>


                    <!-- ===================================================== -->
                    <!-- STEP 2 - SUMMARY -->
                    <!-- ===================================================== -->
                    <v-stepper-content step="2">

                        <v-card
                            class="mb-12"
                            outlined
                        >

                            <v-card-title class="body-2 font-weight-bold">

                                Ringkasan {{
                                    form.leave_category === 'DN'
                                        ? 'Dinas'
                                        : form.leave_category === 'PL'
                                            ? 'Pelatihan'
                                            : 'Meeting di Luar Kantor'
                                }}

                            </v-card-title>


                            <v-card-text class="caption">

                                <v-row align="center">

                                    <v-col cols="6">
                                        Kategori
                                    </v-col>

                                    <v-col
                                        cols="6"
                                        class="font-weight-bold"
                                    >
                                        {{ form.leave_category }} -
                                        {{ form.leave_categorydesc }}
                                    </v-col>


                                    <v-col
                                        cols="6"
                                        class="mt-n5"
                                    >
                                        Tanggal Mulai
                                    </v-col>

                                    <v-col
                                        cols="6"
                                        class="mt-n5 font-weight-bold"
                                    >
                                        {{
                                            $functions.FormatDateIndoWithDayName(
                                                form.leave_sdate
                                            )
                                        }}
                                    </v-col>


                                    <!-- ============================================= -->
                                    <!-- DINAS -->
                                    <!-- ============================================= -->
                                    <template v-if="form.leave_category === 'DN'">

                                        <v-col
                                            cols="6"
                                            class="mt-n5"
                                        >
                                            Tanggal Selesai
                                        </v-col>

                                        <v-col
                                            cols="6"
                                            class="mt-n5 font-weight-bold"
                                        >
                                            {{
                                                $functions.FormatDateIndoWithDayName(
                                                    form.leave_edate
                                                )
                                            }}
                                        </v-col>


                                        <v-col
                                            cols="6"
                                            class="mt-n5"
                                        >
                                            Lama Dinas
                                        </v-col>

                                        <v-col
                                            cols="6"
                                            class="mt-n5 font-weight-bold"
                                        >
                                            {{ form.leave_duration }} Hari
                                        </v-col>

                                    </template>


                                    <!-- ============================================= -->
                                    <!-- PELATIHAN -->
                                    <!-- ============================================= -->
                                    <template v-else-if="form.leave_category === 'PL'">

                                        <v-col
                                            cols="6"
                                            class="mt-n5"
                                        >
                                            Tanggal Selesai
                                        </v-col>

                                        <v-col
                                            cols="6"
                                            class="mt-n5 font-weight-bold"
                                        >
                                            {{
                                                $functions.FormatDateIndoWithDayName(
                                                    form.leave_edate
                                                )
                                            }}
                                        </v-col>


                                        <v-col
                                            cols="6"
                                            class="mt-n5"
                                        >
                                            Lama Pelatihan
                                        </v-col>

                                        <v-col
                                            cols="6"
                                            class="mt-n5 font-weight-bold"
                                        >
                                            {{ form.leave_duration }} Hari
                                        </v-col>


                                        <!--
                                            Jam hanya ditampilkan di Summary
                                            apabila Pelatihan 1 hari
                                        -->
                                        <template v-if="form.leave_duration === 1">

                                            <v-col
                                                cols="6"
                                                class="mt-n5"
                                            >
                                                Jam Mulai
                                            </v-col>

                                            <v-col
                                                cols="6"
                                                class="mt-n5 font-weight-bold"
                                            >
                                                {{ form.leave_stime }}
                                            </v-col>


                                            <v-col
                                                cols="6"
                                                class="mt-n5"
                                            >
                                                Jam Selesai
                                            </v-col>

                                            <v-col
                                                cols="6"
                                                class="mt-n5 font-weight-bold"
                                            >
                                                {{ form.leave_etime }}
                                            </v-col>

                                        </template>

                                    </template>


                                    <!-- ============================================= -->
                                    <!-- MEETING -->
                                    <!-- ============================================= -->
                                    <template v-else>

                                        <v-col
                                            cols="6"
                                            class="mt-n5"
                                        >
                                            Jam Mulai
                                        </v-col>

                                        <v-col
                                            cols="6"
                                            class="mt-n5 font-weight-bold"
                                        >
                                            {{ form.leave_stime }}
                                        </v-col>


                                        <v-col
                                            cols="6"
                                            class="mt-n5"
                                        >
                                            Jam Selesai
                                        </v-col>

                                        <v-col
                                            cols="6"
                                            class="mt-n5 font-weight-bold"
                                        >
                                            {{ form.leave_etime }}
                                        </v-col>


                                        <v-col
                                            cols="6"
                                            class="mt-n5"
                                        >
                                            Lama Meeting
                                        </v-col>

                                        <v-col
                                            cols="6"
                                            class="mt-n5 font-weight-bold"
                                        >
                                            {{ form.leave_durationtime }} Menit
                                        </v-col>

                                    </template>


                                    <!-- ============================================= -->
                                    <!-- DATA UMUM -->
                                    <!-- ============================================= -->
                                    <v-col
                                        cols="6"
                                        class="mt-n5"
                                    >
                                        Alamat
                                    </v-col>

                                    <v-col
                                        cols="6"
                                        class="mt-n5 font-weight-bold"
                                    >
                                        {{ form.leave_address }}
                                    </v-col>


                                    <v-col
                                        cols="6"
                                        class="mt-n5"
                                    >
                                        Peserta
                                    </v-col>

                                    <v-col
                                        cols="6"
                                        class="mt-n5 font-weight-bold"
                                    >
                                        {{ form.leave_participant }}
                                    </v-col>


                                    <v-col
                                        cols="6"
                                        class="mt-n5"
                                    >
                                        Keterangan
                                    </v-col>

                                    <v-col
                                        cols="6"
                                        class="mt-n5 font-weight-bold"
                                    >
                                        {{ form.leave_remarks }}
                                    </v-col>

                                </v-row>

                            </v-card-text>

                        </v-card>


                        <v-btn
                            color="primary"
                            @click="Confirm('add')"
                            block
                            class="mb-2"
                        >
                            Proses
                        </v-btn>


                        <v-btn
                            color="secondary"
                            @click="steppers = 1"
                            block
                        >
                            Sebelumnya
                        </v-btn>

                    </v-stepper-content>

                </v-stepper-items>

            </v-stepper>

        </template>


        <!-- ============================================================= -->
        <!-- CONFIRM -->
        <!-- ============================================================= -->
        <v-dialog
            v-model="confirm.dialog"
            max-width="490"
            persistent
        >

            <v-card>

                <v-card-title class="secondary headline white--text">
                    {{ confirm.title }}
                </v-card-title>

                <v-card-text>
                    {{ confirm.text }}
                </v-card-text>

                <v-card-actions>

                    <v-spacer></v-spacer>

                    <v-btn
                        color="secondary"
                        outlined
                        @click.stop="confirm.dialog = false"
                    >
                        {{ confirm.close }}
                    </v-btn>

                    <v-btn
                        id="dialog_confirm_true"
                        color="primary"
                        outlined
                        :disabled="confirm.ok !== 'OK'"
                        @click="Loading"
                    >
                        {{ confirm.ok }}
                    </v-btn>

                </v-card-actions>

            </v-card>

        </v-dialog>


        <app-snackbar
            :dialog="snackbar.dialog"
            :color="snackbar.color"
            :text="snackbar.text"
            :timeout="snackbar.timeout"
            @close="snackbar.dialog = false"
        ></app-snackbar>

    </div>
</template>


<script>

export default {

    data: () => ({

        steppers: 1,

        url_type: 'add',

        loading: {
            page: false
        },

        form: {

            leave_category: 'MK',
            leave_categorydesc: 'MEETING DI LUAR KANTOR',

            leave_sdate: new Date().toISOString().substr(0, 10),
            leave_sdate_rules: [
                v => !!v || 'Mohon isi Tanggal Mulai'
            ],

            leave_edate: new Date().toISOString().substr(0, 10),
            leave_edate_rules: [
                v => !!v || 'Mohon isi Tanggal Selesai'
            ],

            leave_stime: '',
            leave_stime_rules: [
                v => !!v || 'Mohon isi Jam Mulai'
            ],

            leave_etime: '',
            leave_etime_rules: [
                v => !!v || 'Mohon isi Jam Selesai'
            ],

            leave_remarks: '',
            leave_remarks_rules: [
                v => !!v || 'Mohon masukkan keterangan meeting'
            ],

            leave_address: '',
            leave_address_rules: [
                v => !!v || 'Mohon masukkan alamat'
            ],

            leave_participant: '',
            leave_participant_rules: [
                v => !!v || 'Mohon masukkan peserta'
            ],

            leave_vehicle: 'P',

            usersleave_remaining: 0,
            usersleave_expdate: '',
            usersleave_year: 0,

            leave_duration: 1,
            leave_durationtime: 1

        },


        modal: {

            leave_sdate: false,
            leave_edate: false,

            leave_stime: false,
            leave_etime: false

        },


        confirm: {

            dialog: false,

            title: '',
            text: '',

            ok: 'OK',
            close: 'Tutup'

        },


        snackbar: {

            dialog: false,

            timeout: 3000,

            text: '',

            color: 'error'

        }

    }),


    // =============================================================
    // BACK BUTTON
    // =============================================================
    beforeRouteLeave(to, from, next) {

        if (
            this.modal.leave_sdate ||
            this.modal.leave_edate ||
            this.modal.leave_stime ||
            this.modal.leave_etime
        ) {

            this.modal.leave_sdate = false
            this.modal.leave_edate = false

            this.modal.leave_stime = false
            this.modal.leave_etime = false

            next(false)

        } else {

            next()

        }

    },


    // =============================================================
    // CREATED
    // =============================================================
    created() {

        let now = this.$moment()

        this.form.leave_stime = now.format('HH:mm')

        this.form.leave_etime = now
            .clone()
            .add(1, 'hour')
            .format('HH:mm')

        this.CalculateDuration()

    },


    // =============================================================
    // WATCH
    // =============================================================
    watch: {

        'form.leave_category'(value) {

            // ---------------------------------------------------------
            // PELATIHAN
            // ---------------------------------------------------------
            if (value === 'PL') {

                this.form.leave_categorydesc = 'PELATIHAN'

                this.CalculateDurationDay()

                // Lebih dari 1 hari
                if (this.form.leave_duration > 1) {

                    this.form.leave_stime = '08:00'
                    this.form.leave_etime = '23:59'

                } else {

                    // 1 hari harus dipilih user
                    this.form.leave_stime = ''
                    this.form.leave_etime = ''

                }

            }


            // ---------------------------------------------------------
            // MEETING
            // ---------------------------------------------------------
            if (value === 'MK') {

                this.form.leave_categorydesc =
                    'MEETING DI LUAR KANTOR'

                let now = this.$moment()

                this.form.leave_stime =
                    now.format('HH:mm')

                this.form.leave_etime =
                    now
                        .clone()
                        .add(1, 'hour')
                        .format('HH:mm')

                this.CalculateDuration()

            }


            // ---------------------------------------------------------
            // DINAS
            // ---------------------------------------------------------
            if (value === 'DN') {

                this.form.leave_categorydesc = 'DINAS'

                this.CalculateDurationDay()

            }

        },


        'form.leave_stime'() {

            this.CalculateDuration()

        },


        'form.leave_etime'() {

            this.CalculateDuration()

        },


        'form.leave_sdate'() {

            // Jika tanggal mulai lebih besar dari tanggal selesai
            // otomatis samakan tanggal selesai
            if (
                ['DN', 'PL'].includes(this.form.leave_category) &&
                this.form.leave_edate &&
                this.$moment(this.form.leave_edate)
                    .isBefore(this.$moment(this.form.leave_sdate), 'day')
            ) {

                this.form.leave_edate =
                    this.form.leave_sdate

            }

            this.CalculateDurationDay()

        },


        'form.leave_edate'() {

            this.CalculateDurationDay()

        }

    },


    // =============================================================
    // COMPUTED
    // =============================================================
    computed: {

        leave_sdate_value() {

            return this.form.leave_sdate
                ? this.$moment(this.form.leave_sdate).format('LL')
                : ''

        },


        leave_edate_value() {

            return this.form.leave_edate
                ? this.$moment(this.form.leave_edate).format('LL')
                : ''

        }

    },


    // =============================================================
    // METHODS
    // =============================================================
    methods: {


        GoTo(url) {

            this.$router.push(url)

        },


        // =========================================================
        // CONFIRM
        // =========================================================
        Confirm(flag) {

            if (flag === 'add') {

                this.url_type = flag

                this.confirm.dialog = true

                this.confirm.title = 'Proses'

                setTimeout(function() {

                    document
                        .getElementById('dialog_confirm_true')
                        .focus()

                }, 500)

            }

        },


        // =========================================================
        // LOADING
        // =========================================================
        Loading() {

            this.confirm.ok = 'Loading...'

            if (
                this.url_type === 'add' ||
                this.url_type === 'edit'
            ) {

                this.Write()

            }

        },


        // =========================================================
        // WRITE
        // =========================================================
        Write() {

            /*
             * Safety:
             * PL > 1 hari harus selalu dikirim
             * 08:00 - 23:59
             */
            if (
                this.form.leave_category === 'PL' &&
                this.form.leave_duration > 1
            ) {

                this.form.leave_stime = '08:00'
                this.form.leave_etime = '23:59'

            }


            let formdata = {

                url_type:
                    this.url_type,

                leave_category:
                    this.form.leave_category,

                leave_sdate:
                    this.form.leave_sdate,

                leave_edate:
                    this.form.leave_edate,

                leave_remarks:
                    this.form.leave_remarks,

                leave_year:
                    String(this.form.usersleave_year),

                leave_stime:
                    String(this.form.leave_stime),

                leave_etime:
                    String(this.form.leave_etime),

                leave_duration:
                    String(this.form.leave_duration),

                leave_durationtime:
                    String(this.form.leave_durationtime),

                leave_address:
                    this.form.leave_address,

                leave_participant:
                    this.form.leave_participant,

                leave_usersid:
                    this.$functions.UsersID()

            }


            let param =
                this.$functions.ParamPOST(formdata)


            this.$axios.post(

                this.$functions.UrlPOST('apiWriteLeave'),

                param,

                {

                    headers: {

                        'Content-Type':
                            'text/plain; charset=ISO-8859-1'

                    }

                }

            )

            .then(response => {

                let feedback = response.data

                if (feedback.length > 0) {

                    if (feedback[0].feedback === 'Y') {

                        this.SnackBar(
                            true,
                            'success',
                            'Proses Sukses',
                            3000
                        )

                        this.confirm.dialog = false

                        this.confirm.text = 'Ok'


                        let encodeurl =
                            this.$functions.EncodeUrl(
                                feedback[0].feedback_id
                            )


                        this.$router.push({

                            name:
                                'employeeleavemeetingdetail',

                            params: {
                                id: encodeurl
                            }

                        })

                    } else {

                        this.SnackBar(
                            true,
                            'error',
                            feedback[0].feedback,
                            3000
                        )

                    }

                } else {

                    this.SnackBar(
                        true,
                        'error',
                        this.$functions.ErrorCode(),
                        3000
                    )

                }

            })

            .catch(e => {

                this.SnackBar(
                    true,
                    'error',
                    e,
                    3000
                )

            })

        },


        // =========================================================
        // GET DATA
        // =========================================================
        GetData(flag, value) {

            switch (flag) {

                case 'leave_sdate':

                    this.$refs
                        .dialog_leave_sdate
                        .save(value)

                    this.form.leave_sdate =
                        this.$moment(value)
                            .format('YYYY-MM-DD')

                    break


                case 'leave_edate':

                    this.$refs
                        .dialog_leave_edate
                        .save(value)

                    this.form.leave_edate =
                        this.$moment(value)
                            .format('YYYY-MM-DD')

                    break


                case 'leave_stime':

                    this.$refs
                        .dialog_leave_stime
                        .save(value)

                    this.form.leave_stime =
                        value

                    break


                case 'leave_etime':

                    this.$refs
                        .dialog_leave_etime
                        .save(value)

                    this.form.leave_etime =
                        value

                    break

            }


            this.CalculateDuration()
            this.CalculateDurationDay()

        },


        // =========================================================
        // NEXT STEP
        // =========================================================
        NextStep(id) {

            if (id === 1) {

                if (this.form.leave_category === '') {

                    this.snackbar.dialog = true

                    this.snackbar.text =
                        'Mohon pilih kategori terlebih dahulu'

                    return

                }


                /*
                 * Pelatihan 1 hari:
                 * Jam mulai & selesai wajib
                 */
                if (
                    this.form.leave_category === 'PL' &&
                    this.form.leave_duration === 1
                ) {

                    if (!this.form.leave_stime) {

                        this.SnackBar(
                            true,
                            'error',
                            'Mohon isi Jam Mulai Pelatihan',
                            3000
                        )

                        return

                    }


                    if (!this.form.leave_etime) {

                        this.SnackBar(
                            true,
                            'error',
                            'Mohon isi Jam Selesai Pelatihan',
                            3000
                        )

                        return

                    }

                }


                /*
                 * Pelatihan > 1 hari:
                 * Jam otomatis.
                 */
                if (
                    this.form.leave_category === 'PL' &&
                    this.form.leave_duration > 1
                ) {

                    this.form.leave_stime = '08:00'
                    this.form.leave_etime = '23:59'

                }


                if (
                    this.$refs
                        .form_leave_data
                        .validate()
                ) {

                    this.steppers = 2

                }

            }

        },


        // =========================================================
        // CALCULATE DURATION DAY
        // =========================================================
        CalculateDurationDay() {

            if (
                !['DN', 'PL']
                    .includes(this.form.leave_category)
            ) {

                return

            }


            if (
                !this.form.leave_sdate ||
                !this.form.leave_edate
            ) {

                return

            }


            let start =
                this.$moment(
                    this.form.leave_sdate
                )
                .startOf('day')


            let end =
                this.$moment(
                    this.form.leave_edate
                )
                .startOf('day')


            let diff =
                end.diff(start, 'days') + 1


            if (diff < 1) {

                diff = 1

            }


            this.form.leave_duration = diff


            /*
             * LOGIC PELATIHAN
             *
             * > 1 hari
             * otomatis 08:00 - 23:59
             *
             * 1 hari
             * jam ditentukan user.
             */
            if (
                this.form.leave_category === 'PL' &&
                diff > 1
            ) {

                this.form.leave_stime = '08:00'

                this.form.leave_etime = '23:59'

            }

        },


        // =========================================================
        // CALCULATE DURATION TIME
        // =========================================================
        CalculateDuration() {

            if (
                !this.form.leave_stime ||
                !this.form.leave_etime
            ) {

                return

            }


            let start =
                this.$moment(
                    this.form.leave_stime,
                    'HH:mm'
                )


            let end =
                this.$moment(
                    this.form.leave_etime,
                    'HH:mm'
                )


            let diff =
                end.diff(start, 'minutes')


            if (diff < 0) {

                diff = 0

            }


            this.form.leave_durationtime =
                diff

        },


        // =========================================================
        // SNACKBAR
        // =========================================================
        SnackBar(
            dialog,
            color,
            text,
            timeout
        ) {

            this.snackbar = {

                dialog: dialog,

                color: color,

                text: text,

                timeout: timeout

            }


            if (color === 'error') {

                this.confirm.dialog = false

                this.confirm.ok = 'OK'

            }

        }

    }

}

</script>